import { responsiveWidthBreakpoints } from 'settings/theme';
/**
 * To be used with react-grid-system's ScreenClassRender
 * This provides a consistent definition for "small screen" and "large screen"
 */
class ScreenSizeUtil {
    static _getViewPort() {
        if (typeof window !== 'undefined' && window.innerWidth) {
            return window.innerWidth;
        }
        return null;
    };

    static getScreenClass() {
        let screenClass = 'lg';

        const viewport = this._getViewPort();
        if (viewport) {
            screenClass = 'xs';
            if (responsiveWidthBreakpoints[0] && viewport >= responsiveWidthBreakpoints[0]) screenClass = 'sm';
            if (responsiveWidthBreakpoints[1] && viewport >= responsiveWidthBreakpoints[1]) screenClass = 'md';
            if (responsiveWidthBreakpoints[2] && viewport >= responsiveWidthBreakpoints[2]) screenClass = 'lg';
            if (responsiveWidthBreakpoints[3] && viewport >= responsiveWidthBreakpoints[3]) screenClass = 'xl';
        }

        return screenClass;
    }

    static isSmallScreen(screenClass) {
        return ['xs', 'sm'].includes(screenClass);
    }

    static isLargeScreen(screenClass) {
        return ['md', 'lg', 'xl'].includes(screenClass);
    }
}

export default ScreenSizeUtil;



// WEBPACK FOOTER //
// ./src/utils/ScreenSizeUtil.js